"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = groupsReducer;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _transform = _interopRequireDefault(require("lodash/transform"));
var _actionTypes = require("../actions/actionTypes");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function groupsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _actionTypes.LOAD_OPTIONS_SUCCESS:
      {
        // eslint-disable-next-line no-param-reassign
        return (0, _transform["default"])(action.groups, function (groups, g, gid) {
          return groups[gid] = _objectSpread(_objectSpread({}, g), {}, {
            options: g.options.filter(function (oid) {
              return action.options[oid].isActive;
            })
          });
        }, {});
      }
    case _actionTypes.CLEAR_STATE:
      {
        return {};
      }
    default:
      return state;
  }
}
//# sourceMappingURL=groupsReducer.js.map